import { render } from "./UserBotIndexView.vue?vue&type=template&id=00377381&scoped=true"
import script from "./UserBotIndexView.vue?vue&type=script&lang=js"
export * from "./UserBotIndexView.vue?vue&type=script&lang=js"

import "./UserBotIndexView.vue?vue&type=style&index=0&id=00377381&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00377381"]])

export default __exports__